import getByIdPropReduxSelector from '../../../../redux/selectors/get-by-id-prop'
import WORKOUT_SECTIONS_PATH from '../../constants/path'

const getByIdPropWorkoutSectionSelect = getByIdPropReduxSelector(
  WORKOUT_SECTIONS_PATH.DATA)

export default getByIdPropWorkoutSectionSelect
